import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { UserNotifyService } from 'src/app/core/notify/user-notify.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LoginBottomSheetComponent } from '../login-bottom-sheet/login-bottom-sheet.component';

@Injectable({
  providedIn: 'root'
})
export class GuardService implements CanActivate {

  constructor(public auth: AuthService, public router: Router,
    public toast: UserNotifyService,
    private bottomSheet: MatBottomSheet,

  ) { }

  canActivate(): boolean {
    console.log('canActiveeeee', this.auth.isAuthenticated().value);

    if (this.auth.isAuthenticated().value === false) {
      this.toast.showWarning('برای ادامه باید وارد حساب کاربریت بشی')
      this.router.navigate(['/']);
      const bottomSheetRef = this.bottomSheet.open(LoginBottomSheetComponent, {
        data: {
          loginState: 'auth',
        },
      });
      return false;
    } else {
      return true;
    }

  }
  // canActivate(): Observable<boolean> {
  //   return this.auth.isAuthenticated().pipe(map(
  //     auth => {
  //       if (!auth) {
  //         this.router.navigate(['auth']);
  //         return false;
  //       }
  //       else {
  //         if (!this.detectBrowser()) {
  //           alert('ورود به سایت فقط با مرورگر های کروم و فایرفاکس موزیلا امکان پذیر است');
  //           this.router.navigate(['auth']);
  //           return false;
  //         }
  //         return true;
  //       }
  //     }
  //   ));
  // }

  // detectBrowser() {
  //   if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1) {
  //     // return 'Opera';
  //     return false;
  //   } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
  //     // return 'Chrome';
  //     return true;
  //   } else if (navigator.userAgent.indexOf('Safari') !== -1) {
  //     // return 'Safari';
  //     return true;
  //   } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
  //     // return 'Firefox';
  //     return true;
  //   } else if ((navigator.userAgent.indexOf('MSIE') !== -1)) {
  //     // return 'IE';//crap
  //     return false; // crap
  //   } else {
  //     // return 'Unknown';
  //     return false;
  //   }
  // }

}